// extracted by mini-css-extract-plugin
export default {"feedback":"Feedback_feedback__69etg","thankYou":"Feedback_thankYou__msEq0","loading":"Feedback_loading__0CfIw","loader":"Feedback_loader__FdQ67","error":"Feedback_error__Jcwpb"};